__turbopack_context__.v({
  "btnClear": "accessories-section-module-scss-module__jguuPq__btnClear",
  "modal": "accessories-section-module-scss-module__jguuPq__modal",
  "section": "accessories-section-module-scss-module__jguuPq__section",
  "title": "accessories-section-module-scss-module__jguuPq__title",
  "wrapper": "accessories-section-module-scss-module__jguuPq__wrapper",
});
